import { Inject, Injectable } from '@angular/core';
import {
  Persone,
  IsError,
  Environment,
  Persone_TableModel,
  Persone_ChecksFormModel,
  IProfiloUtenteModel,
  ModelNumStr,
  ModelNumStrGroup,
} from '../../models/-index';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CrudGenericsService } from '../common/crud-generics';

@Injectable()
export class PersoneService extends CrudGenericsService<Persone, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/Persone`);
    this.base = `${env.apiUrl}/api/Persone/`;
  }

  Get4SelectGroup(): Observable<ModelNumStrGroup[]> {
    const u = this.base + 'Get4SelectGroup';
    return this.http.get<ModelNumStrGroup[]>(`${u}`);
  }

  Get4Select_ByIdPersonaTipo(id: number): Observable<ModelNumStr[]> {
    const u = this.base + 'Get4Select_ByIdPersonaTipo?id=' + id;
    return this.http.get<ModelNumStr[]>(`${u}`);
  }
  // AddPersona_UpdUtente
  AddPersona_UpdUtente(item: Persone, ute: string): Observable<number> {
    const u = this.base + 'AddPersona_UpdUtente?ute=' + ute;
    return this.http.post<number>(`${u}`, item);
  }
  // per la tabella
  GetPersone_TableModel(): Observable<Persone_TableModel[]> {
    const u = this.base + 'GetPersone_TableModel';
    return this.http.get<Persone_TableModel[]>(`${u}`);
  }

  // univoco Codice
  checkUnique_CodicePersona(str: string, id: number): Observable<IsError> {
    const u = this.base + 'checkUnique_CodicePersona?str=' + str + '&id=' + id;
    return this.http.get<IsError>(`${u}`);
  }
  // web
  ChecksFormModel_ByPersona(id: number): Observable<Persone_ChecksFormModel> {
    const u = this.base + 'ChecksFormModel_ByPersona?id=' + id;
    return this.http.get<Persone_ChecksFormModel>(`${u}`);
  }
  // web
  GetPersona_ByEmail(email: string): Observable<Persone> {
    const u = this.base + 'GetPersona_ByEmail?email=' + email;
    return this.http.get<Persone>(`${u}`);
  }
  // web add
  FastAddExistingPersonaToAzb(model: IProfiloUtenteModel) {
    const u = this.base + 'FastAddExistingPersonaToAzb';
    return this.http.post<number>(`${u}`, model);
  }
}
